import Vue from "vue";
import Vuex from "vuex";

import assignments from "./assignments";
import documents from "./documents";
import files_temp from "./files_temp";
import sections from "./sections";
import settings from "./settings";
import setup from "./setup";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    assignments,
    documents,
    files_temp,
    sections,
    settings,
    setup
  },
  actions: {
    resetStore({ commit }) {
      commit("documents/resetStateData");
      commit("sections/resetStateData");
    }
  }
});

export default store;
